import { render, staticRenderFns } from "./mobileVerification.vue?vue&type=template&id=4c76d9f6&scoped=true"
import script from "./mobileVerification.vue?vue&type=script&lang=js"
export * from "./mobileVerification.vue?vue&type=script&lang=js"
import style0 from "./mobileVerification.vue?vue&type=style&index=0&id=4c76d9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c76d9f6",
  null
  
)

export default component.exports